// TODO: remove file once connected to backend
import { sortByKey } from '@app/shared/utils/common';
import { User } from '@app/shared/types/admin/pages/users';
import { FindUserBy } from '@app/shared/types/admin/common';
import { PriceType } from '@app/shared/types/common';

function getRandomInt(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function createMockUser(id: number): User {
  const randomUsername = `user${id}`;
  const randomFullName = `User ${id}`;
  const telegramId = getRandomInt(100000000, 999999999);
  const cookieBalance = parseFloat((Math.random() * 1000).toFixed(2));
  const tonBalance = parseFloat((Math.random() * 50).toFixed(2));
  const hasFrozen = Math.random() > 0.5;
  const frozenTonBalance = hasFrozen ? parseFloat((Math.random() * 10).toFixed(2)) : undefined;

  return {
    id,
    telegramId,
    telegramUsername: randomUsername,
    fullName: randomFullName,
    cookieBalance,
    tonBalance,
    ...(hasFrozen && { frozenTonBalance }),
  };
}

function createMockUsers(count: number): User[] {
  return Array.from({ length: count }, (_, i) => createMockUser(i + 1));
}

export const getUsers = ({
  balanceType,
  page,
  limit,
}: {
  findUserBy: FindUserBy;
  findUserValue: string;
  balanceType: PriceType;
  page: number;
  limit: number;
}) => {
  const mockUsers = createMockUsers(100);
  const sortedMockUsers = sortByKey(
    mockUsers,
    balanceType === 'cookie' ? 'cookieBalance' : 'tonBalance',
    'desc'
  );

  return {
    items: sortedMockUsers.slice((page - 1) * limit, page * limit),
    total: sortedMockUsers.length,
  };
};
